import { useTheme } from "@material-ui/core"
import * as React from "react"

function PageInput({
  actualValue,
  totalPages,
  pageSize,
  handleChangePagination,
}: {
  actualValue: string
  totalPages: number
  pageSize: number
  handleChangePagination: (newPage: number, newPageSize: number) => void
}) {
  // State to track whether the input is focused
  const [isFocused, setIsFocused] = React.useState(false)

  // State to track the value of the input
  const [inputValue, setInputValue] = React.useState(actualValue)

  // Get theme
  const theme = useTheme()

  // Inline style object
  const inputStyle = {
    borderColor: isFocused
      ? `${theme.palette.primary.main}`
      : "var(--disabled-grey)", // Change border color on focus
    borderWidth: isFocused ? "2px" : "1px", // Change border width on focus
    borderStyle: "solid",
    borderRadius: "4px",
    outline: "0",
    width: "30px",
    height: "28px",
    fontSize: "14px",
  }

  return (
    <input
      style={{ textAlign: "center", ...inputStyle }}
      placeholder={actualValue}
      value={inputValue}
      onChange={(event) => setInputValue(event.target.value)}
      onFocus={() => setIsFocused(true)} // Focus handler
      onBlur={() => {
        setIsFocused(false)
        if (inputValue === "" || inputValue !== actualValue) {
          setInputValue(actualValue) // Revert to actualValue if input is empty or different
        }
      }}
      onKeyUp={(event) => {
        if (event.key === "Enter") {
          const goToPage = parseInt(inputValue)
          if (!goToPage) {
            setInputValue(actualValue) // Reset input to actualValue if invalid number
            return
          }
          if (goToPage > totalPages || goToPage < 1) return
          handleChangePagination(goToPage - 1, pageSize) // Call the pagination handler
        }
      }}
    />
  )
}

export { PageInput }
